module.exports = "/_onelink_/fastheroes/projects/fastheroes/enus2elgr/images/ebook/base_64/SAD.png"